import LiveSummaryTable from "./live-summary-table";
import SelectTagGroups from "components-for/filters/select-tag-groups";
import useTagGroups from "hooks-for/tag-groups/use-tag-groups";
import { Box, BoxContent, BoxHeader, BoxHeading, FieldInline } from "@edgetier/client-components";
import { faTag } from "@fortawesome/pro-solid-svg-icons";
import { Form, Formik } from "formik";
import { FunctionComponent, memo } from "react";
import { IProps } from "./live-summary-tab.types";
import { SubmitOnChange } from "@edgetier/components";
import { TagGroupType } from "@edgetier/watchtower-types";
import { useSummaryTagGroup } from "./live-summary-tab.utilities";
import "./live-summary-tab.scss";

/**
 * Display live interactions data for a tag group as a table
 */
const LiveSummaryTab: FunctionComponent<IProps> = () => {
    const [tagGroupSelectedId, setTagGroupSelectedId] = useSummaryTagGroup(undefined);

    // Find the name of the selected tag group.
    const { data: tagGroup, isLoading: isTagGroupsLoading } = useTagGroups(
        {},
        { select: (tagGroups) => (tagGroups ?? []).find((tagGroup) => tagGroup.tagGroupId === tagGroupSelectedId) }
    );

    /**
     * Handle the user selecting a tag group.
     * @param values Selected tag group.
     */
    const onSubmit = (values: { tagGroupId: string }) => {
        setTagGroupSelectedId(values.tagGroupId);
    };

    return (
        <Box className="live-summary-tab">
            <BoxHeader>
                <BoxHeading>
                    <div>{typeof tagGroup !== "undefined" ? `${tagGroup.tagGroup} Summary` : `Tag Group Summary`}</div>
                </BoxHeading>
                <Formik initialValues={{ tagGroupId: tagGroupSelectedId ?? "" }} onSubmit={onSubmit}>
                    <Form name="live-summary-tag-group-form">
                        <div className="tag-group-select">
                            <FieldInline icon={faTag}>
                                <SelectTagGroups
                                    name="tagGroupId"
                                    isSingleSelect
                                    hasAddItemMenu={false}
                                    selectTagGroups={(tagGroups) =>
                                        tagGroups.filter((tagGroup) =>
                                            [TagGroupType.External, TagGroupType.PhraseSearch].includes(
                                                tagGroup.tagGroupType
                                            )
                                        )
                                    }
                                />
                            </FieldInline>
                        </div>
                        <SubmitOnChange />
                    </Form>
                </Formik>
            </BoxHeader>
            <BoxContent>
                <div className="live-summary-tab__container">
                    <LiveSummaryTable key={tagGroupSelectedId} />
                </div>
            </BoxContent>
        </Box>
    );
};

export default memo(LiveSummaryTab);
